module.exports = __webpack_public_path__ + "img/SMT_48_Lok_Yoke_Har.fe05172b.jpg";